import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main-section" }
const _hoisted_2 = { class: "content-section" }
const _hoisted_3 = { class: "game-description first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Accent = _resolveComponent("Accent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _cache[9] || (_cache[9] = _createElementVNode("picture", {
        class: "image right",
        style: {"width":"50%"}
      }, [
        _createElementVNode("source", {
          srcset: "/msfs/src/img/msfs_credits.webp",
          type: "image/webp"
        }),
        _createElementVNode("source", {
          srcset: "/msfs/src/img/msfs_credits.jpg",
          type: "image/jpg"
        }),
        _createElementVNode("img", {
          src: "/msfs/src/img/msfs_credits.jpg",
          alt: ""
        })
      ], -1)),
      _createElementVNode("p", _hoisted_3, [
        _cache[4] || (_cache[4] = _createTextVNode(" I worked as a ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createTextVNode("Gameplay Programmer")
          ])),
          _: 1
        }),
        _cache[5] || (_cache[5] = _createTextVNode(" on Microsoft Flight Simulator 2024, contributing to ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("port work")
          ])),
          _: 1
        }),
        _cache[6] || (_cache[6] = _createTextVNode(" and ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("additional content for the Reno gamemode")
          ])),
          _: 1
        }),
        _cache[7] || (_cache[7] = _createTextVNode(", as well as ")),
        _createVNode(_component_Accent, null, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("creating the new Red Bull gamemode")
          ])),
          _: 1
        }),
        _cache[8] || (_cache[8] = _createTextVNode(". While specific details remain under NDA, my work involved implementing gameplay systems and features and creating mission-info. "))
      ]),
      _cache[10] || (_cache[10] = _createElementVNode("h1", { class: "game-description" }, "Things I learned", -1)),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectData.learn, (task, index) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "game-description game-list",
            key: index
          }, _toDisplayString(task), 1))
        }), 128))
      ]),
      _cache[11] || (_cache[11] = _createElementVNode("p", { class: "game-description" }, " I worked on the PlayStation 5 port of Microsoft Flight Simulator for a short period, before being moved to one of the gameplay projects for the game. ", -1))
    ])
  ]))
}